<template>
    <button :data-id="item.id" :class="itemClass(item)" @click="openItem($event, item)">
        
        <i class="material-icons">{{ learning_unit_icons[item.type] }}</i>

        <div class="trax-top-left-icon">
            <i class="material-icons" v-if="item.meta.remedial">replay</i>
            <i class="material-icons" v-if="itemProcedure(item)">call_missed_outgoing</i>
            <i class="material-icons" v-if="itemDowngraded(item)">arrow_downward</i>
        </div>

        <div class="trax-top-right-icon" v-if="item.meta.assessment">
            <i class="material-icons">check</i>
        </div>

        <div class="trax-code">{{ item.code }}</div>

        <div :class="progressClass(item)" :style="progressStyle(item)" v-if="!individual && itemStarted(item) && !itemCompleted(item)"></div>
    </button>
</template>

<script>
    export default {

        props: {

            id: null,
            bus: null,
            
            individual: {
                type: Boolean,
                default: false
            },
            
            item: {
                type: Object,
                required: true
            },

            states: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                learning_unit_icons: data.learning_unit_icons
            }
        },

        methods: {

            itemStarted(item) {
                return this.states[item.id] && this.states[item.id].completion && this.states[item.id].completion.percent > 0;
            },

            itemCompleted(item) {
                return this.states[item.id] && this.states[item.id].completed;
            },

            itemProcedure(item) {
                return this.states[item.id] && this.states[item.id].procedure;
            },

            itemDowngraded(item) {
                return this.states[item.id] && this.states[item.id].downgrade;
            },

            itemClass(item) {
                var color_status
                if (this.individual) {
                    color_status = this.states[item.id] ? this.states[item.id].color_status : 'default';
                } else {
                    color_status = this.itemCompleted(item) ? this.states[item.id].color_status : 'default';
                }
                var optional = item.optional ? ' trax-optional' : '';
                return 'btn btn-lg trax-btn-square btn-'+color_status+optional;
            },

            progressClass(item) {
                var color_status = this.states[item.id] ? this.states[item.id].color_status : 'default';
                return 'trax-progress-value bg-'+color_status;
            },

            progressStyle(item) {
                var width = this.states[item.id] ? this.states[item.id].completion.percent : 0;
                return 'width:'+width+'%';
            },

            openItem(event, item) {
                var headerColor = this.states[item.id] ? this.states[item.id].color_status : 'default';
                if (this.states[item.id]) item.state = this.states[item.id];
                this.bus.$emit(this.id+'-details-open', {icon: this.learning_unit_icons[item.type], title: item.code, data: item, headerColor: headerColor});
            }
        }
    }
</script>
